import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author @omerrkosar
 */

export const CustomReport1Config = {
	id: DYNAMICLISTS.CUSTOM_REPORT_1,
	columns: [
		{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50, show: false, showCopyButton: true },
		{
			Header: 'orderID',
			accessor: 'orderID',
			filterType: FilterType.string,
			width: 70,
			showOnMobile: true,
			showCopyButton: true
		},
		{
			Header: 'date',
			accessor: 'orderDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME,
			customFilterOptions: [FilterAction.between, FilterAction.on]
		},
		{
			Header: 'brandName',
			accessor: 'storeName',
			filterType: FilterType.enumMulti,
			width: 70,
			enumName: 'brandName',
			roleName: 'BrandingModule'
		},
		{ Header: 'orderTime', accessor: 'orderTime', filterType: FilterType.string, width: 200 },
		{
			Header: 'customerName',
			accessor: 'customerName',
			filterType: FilterType.string,
			showOnMobile: true
		},
		{
			Header: 'city',
			accessor: 'city',
			filterType: FilterType.multiSelection,
			showOnMobile: true
		},
		{
			Header: 'cityDescription',
			accessor: 'cityDescription',
			filterType: FilterType.string,
			showOnMobile: true
		},
		{
			Header: 'googleAddress',
			accessor: 'googleAddress',
			filterType: FilterType.string,
			showOnMobile: true
		},
		{
			Header: 'qty',
			accessor: 'qty',
			filterType: FilterType.number,
			showOnMobile: true
		},
		{
			Header: 'packageCount',
			accessor: 'packageCount',
			filterType: FilterType.number,
			showOnMobile: true
		},
		{
			Header: 'callDriverTime',
			accessor: 'shipmentCreationDate',
			filterType: FilterType.number,
			showOnMobile: true,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'deliveryDate',
			accessor: 'deliveryDate',
			filterType: FilterType.date,
			showOnMobile: true
		},
		{
			Header: 'comments',
			accessor: 'comments',
			filterType: FilterType.string,
			showOnMobile: true
		},
		{
			Header: 'sapApprovalDate',
			accessor: 'sapApprovalDate',
			filterType: FilterType.date,
			width: 70
		},
		{
			Header: 'pickingDate',
			accessor: 'pickingDate',
			filterType: FilterType.date,
			width: 70
		}
	],
	fetchUrl: REPORT.LIST.GET_CUSTOM_REPORT_1_LIST,
	defaultSort: [{ id: 'ID', desc: true }],
	exportName: 'customReport1'
};

const CustomReport1 = () => (
	<div>
		<HeaderContainerFormHeader>
			<FormHeader
				lightTitle="reports"
				boldTitle="customReport1"
				icon={faArrowLeft}
				backUrl={mergePaths(PATHS.REPORTS, PATHS.ORDER_REPORTS)}
			/>
		</HeaderContainerFormHeader>
		<DynamicList {...CustomReport1Config} />
	</div>
);

export default CustomReport1;
